export interface EnrichmentMetaLike {
  enrichment_status?: string | null
  fetched_on?: string | null
}

export interface EnrichmentDisplayState {
  label: string
  pillClass: string
  description?: string
}

export const formatEnrichmentDate = (value?: string | null) => {
  if (!value) return null
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return null
  return parsed.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' })
}

export const getEnrichmentDisplayState = (
  meta?: EnrichmentMetaLike | null
): EnrichmentDisplayState => {
  const status = (meta?.enrichment_status || '').toLowerCase()
  const lastRun = formatEnrichmentDate(meta?.fetched_on)

  if (status === 'enriched') {
    return {
      label: 'Enriched',
      pillClass: 'bg-emerald-50 text-emerald-700 border-emerald-200',
      description: lastRun ? `Updated ${lastRun}` : 'Marketing copy ready'
    }
  }

  if (status === 'pending') {
    return {
      label: 'Enriching',
      pillClass: 'bg-amber-50 text-amber-700 border-amber-200',
      description: 'Agent running'
    }
  }

  if (status === 'failed') {
    return {
      label: 'Needs Attention',
      pillClass: 'bg-red-50 text-red-700 border-red-200',
      description: lastRun ? `Failed ${lastRun}` : 'Retry required'
    }
  }

  return {
    label: 'Not Enriched',
    pillClass: 'bg-slate-50 text-slate-600 border-slate-200',
    description: 'Agent not run'
  }
}
